import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var OPEN_MENU = "OPEN_MENU";
var CLOSE_MENU = "CLOSE_MENU";
var TOGGLE_MENU = "TOGGLE_MENU";
var initialState = {
  isOpen: false
};
export function sidebarPanelReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case OPEN_MENU:
      return _objectSpread(_objectSpread({}, state), {}, {
        isOpen: true
      });
    case CLOSE_MENU:
      return _objectSpread(_objectSpread({}, state), {}, {
        isOpen: false
      });
    case TOGGLE_MENU:
      return _objectSpread(_objectSpread({}, state), {}, {
        isOpen: !state.isOpen
      });
    default:
      return state;
  }
}
export var isSidebarMenuOpen = function isSidebarMenuOpen(state) {
  var _state$burgerMenu;
  return state === null || state === void 0 || (_state$burgerMenu = state.burgerMenu) === null || _state$burgerMenu === void 0 ? void 0 : _state$burgerMenu.isOpen;
};
export var openMenu = function openMenu() {
  return {
    type: OPEN_MENU
  };
};
export var closeMenu = function closeMenu() {
  return {
    type: CLOSE_MENU
  };
};
export var toggleMenu = function toggleMenu() {
  return {
    type: TOGGLE_MENU
  };
};